var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketGrowth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1127 9.88633C20.9286 8.07048 21.9671 5.62609 21.9999 3.09088C22.0078 2.48056 21.5194 1.9922 20.9091 2.00009C18.3739 2.03289 15.9295 3.07145 14.1137 4.8873L10.2164 8.78461L8.42487 8.20832C7.78426 8.00225 7.07279 8.1789 6.58706 8.66464L5.13525 10.1165C4.95815 10.2935 4.9545 10.577 5.12709 10.7496L13.2504 18.8729C13.423 19.0455 13.7065 19.0418 13.8835 18.8648L15.3354 17.4129C15.8211 16.9272 15.9978 16.2157 15.7917 15.5751L15.2154 13.7836L19.1127 9.88633Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketGrowth2);
export default __webpack_public_path__ + "static/media/rocket-growth-2.187108a4564b603b267edaa9388f1064.svg";
export { ForwardRef as ReactComponent };